import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './embalagemInventarioForm';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { setModoTela, initForm, setFiltro, salvar, excluir, getLista, getListaFornecedor, getListaEstoqueLocal } from './embalagemInventarioActions';

class EmbalagemInventario extends Component {

	state = {
		pesquisar: '',
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaFornecedor();
		this.props.getListaEstoqueLocal();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro');
									this.props.initForm();
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>

					<Row>
						<LabelAndInputMask
							label='Data Incial' placeholder='Informe a data'
							cols='12 6 3 2'
							mask='99/99/9999'
							value={this.props.filtro.data_inicial}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_inicial: data.target.value });
								this.props.getLista();
							}} />

						<LabelAndInputMask
							label='Data Final' placeholder='Informe a data'
							cols='12 6 3 2'
							mask='99/99/9999'
							value={this.props.filtro.data_final}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_final: data.target.value });
								this.props.getLista();
							}} />
					</Row>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />

					<Table responsive>
						<THead>
							<Tr>
								<Th>Agendamento</Th>
								<Th>Realização</Th>
								<Th>Local</Th>
								<Th>Fornecedor</Th>
								<Th>Responsável</Th>
								<Th alignCenter>Termo</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao)} ${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inventario)} ${item.nome_local} ${item.nome_fornecedor} ${item.responsavel}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao)}</Td>
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inventario)}</Td>
									<Td>{item.nome_local}</Td>
									<Td>{item.nome_fornecedor}</Td>
									<Td>{item.responsavel}</Td>
									<Td alignCenter>
										{item.arquivo_termo ? (
											<ButtonTable
												type={'primary'}
												icon={`fas fa-${item.arquivo_termo.includes('data:image') ? 'file-image'
													: (item.arquivo_termo.includes('data:application/pdf') ? 'file-pdf' : 'file-alt')}`}
												visible={true}
												event={() => {
													const linkSource = item.arquivo_termo;
													const downloadLink = document.createElement("a");
													const fileName = 'Inventário';
													downloadLink.href = linkSource;
													downloadLink.download = fileName;
													downloadLink.click();
												}} />
										) : null}
									</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_inventario: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inventario)
												});
												this.props.initForm({
													...item,
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_inventario: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inventario)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_inventario: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inventario)
												});
												this.props.initForm({
													...item,
													datahora_previsao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao),
													datahora_inventario: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inventario)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.embalagemInventario.modoTela,
	filtro: state.embalagemInventario.filtro,
	lista: state.embalagemInventario.lista,
	listaFornecedor: state.embalagemInventario.listaFornecedor,
	listaEstoqueLocal: state.embalagemInventario.listaEstoqueLocal
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, setFiltro, salvar, excluir, getLista, getListaFornecedor, getListaEstoqueLocal }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EmbalagemInventario);
